import React, { useCallback, useRef } from "react"
import { SimplesPagina } from "../../templates"
import { Box, Button, Grid, Typography } from "@material-ui/core"
import { isEmpty } from "lodash"
import { CancelarIcon } from "components/icons/cancelar-icon"
import { OkIcon } from "utils/Icons/ok-icon"
import { useStyles } from "./convite-empresa-styles"
import { useHistory, useLocation } from "react-router-dom"
import { usePostIdentidadeConfirmarUsuario } from "api/touchone/requests/post-confirmar-usuario"
import { useConfirm } from "material-ui-confirm"
import { useNotificacoes } from "components"
import { ConviteFormModel } from "models/app/forms/auth/convite-form-model"
import { picker } from "utils/picker"
import { FormConvite } from "components/forms/convite/form-convite"
import { DefaultFormRefs } from "components/forms/utils"
import { useObterToken } from "services/store/obter-token"

export const ConviteUsuarioPage = () => {

    const confirm = useConfirm()
    const { showErrorMessage, showSuccessMessage } = useNotificacoes()

    const { postIdentidadeConfirmarUsuario, carregando } = usePostIdentidadeConfirmarUsuario()
    const { setToken, getTokenConvert } = useObterToken()

    const history = useHistory()
    const search = useLocation().search;
    const pegarParams = new URLSearchParams(search).get('chave');

    const decodarChave = atob(pegarParams || '').split('|')

    const [id, identificacao] = decodarChave
    const classes = useStyles()
    const conviteRefs =
        useRef<DefaultFormRefs<ConviteFormModel>>(null);

    const atualizarNovoUsuario = useCallback(
        async (model: ConviteFormModel) => {
            try {
                const ret = await postIdentidadeConfirmarUsuario(model);
                if (ret.erro) {
                    throw ret.erro;
                }
                showSuccessMessage("Convite confirmado com sucesso!");
                if (ret.resultado?.status === 300) {
                    // TODO: CHAMAR DIALOG DE MULTICONTRATO PARA SELECIONAR UM E ENTRAR NA EMPRESA
                    return
                }
                const token = ret.resultado?.data.accessToken || ''

                setToken(token)
                const tokenConvert = getTokenConvert(token)
                const getEmpresaId = tokenConvert?.empresa?.[0]?.Id
                history.push(`/${getEmpresaId ?? ''}`)

            } catch (e: any) {
                showErrorMessage(e.message);
            }
        },
        [getTokenConvert, history, postIdentidadeConfirmarUsuario, setToken, showErrorMessage, showSuccessMessage]
    )

    const handleSubmit = useCallback(
        async (modelP: ConviteFormModel) => {
            const conviteToUpdate = picker<ConviteFormModel>(modelP, new ConviteFormModel());
            conviteToUpdate.id = id
            if (/^\d+$/.test(identificacao)) {
                conviteToUpdate.telefone = identificacao
            } else {
                conviteToUpdate.email = identificacao
            }
            return atualizarNovoUsuario(conviteToUpdate);
        },
        [atualizarNovoUsuario, identificacao, id]
    )

    const rejeitarConvite = useCallback(() => {
        confirm({
            title: "Deseja recusar o convite?",
            cancellationText: "Recusar",
            confirmationText: "Continuar",
        }).catch(() => {
            history.push('/')
        });
    }, [confirm, history]
    );
    return (
        <SimplesPagina>
            <Grid container spacing={2} className={classes.container}>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12} md={6}>
                            <Typography align="center" variant="h3" color="primary">
                                Aceitar Convite
                            </Typography>
                            <Box mt={3} mb={3}>
                                <Typography align="center" variant="body1" >
                                    Informe sua senha de acesso para confirmar seu convite
                                </Typography>
                            </Box>
                            <Box mt={3} mb={3}>
                                <Typography align="center" variant="body1" >
                                    {!isEmpty(identificacao) ?
                                        identificacao : ''
                                    }
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={8} lg={8} container spacing={2}>
                            <Grid item xs={12}>
                                <FormConvite
                                    ref={conviteRefs}
                                    loading={carregando}
                                    showLoading={false}
                                    onSubmit={handleSubmit}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    className={classes.button}
                                    fullWidth
                                    disabled={carregando}
                                    onClick={rejeitarConvite}
                                >
                                    <CancelarIcon tipo="BUTTON" />
                                    Recusar Convite
                                </Button>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    disabled={carregando}
                                    className={classes.button}
                                    onClick={() => conviteRefs.current?.submitForm()}
                                >
                                    <OkIcon tipo="BUTTON_PRIMARY" />
                                    Aceitar Convite
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </SimplesPagina>
    )
}
